function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKSIG opcode — verify witness signature against message and publickey.
 */

module.exports = {
  name: 'CHECKSIG',
  description: 'Verify a signature against a message.',
  exampleScript: {
    op: 'CHECKSIG',
    publickey: '<publickey>',
    msg: '<text>',
    witness: {
      signature: '<signature>'
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!context.app || !context.app.crypto || typeof context.app.crypto.verifyMessage !== 'function') {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(witness, 'signature')) {
      return false;
    }
    var signature = witness.signature;
    if (typeof signature !== 'string' || signature.length === 0) {
      return false;
    }
    var msg = node.msg;
    if (typeof msg !== 'string' || msg.length === 0) {
      return false;
    }
    var publickey = node.publickey;
    if (typeof publickey !== 'string' || publickey.length === 0) {
      return false;
    }
    return context.app.crypto.verifyMessage(msg, signature, publickey) === true;
  }
};